export const validatePageIndex = (page, totalPages) => {
  let add = -1;

  if (page - 1 <= 0) {
    add = 0;
  } else if (page + 1 > totalPages && totalPages !== 2) {
    add = -2;
  }
  return page + add;
};

export const getPageRange = (page, totalPages) => {
  const prevPage = validatePageIndex(page, totalPages);
  const rangeLength = 3;
  const range = [];
  for (let i = 0; i < rangeLength; i++) {
    if (prevPage + i <= totalPages) {
      range.push({index: prevPage + i, active: page === prevPage + i});
    }
  }
  return range;
};

export const getActiveIndex = range => {
  let index;
  for (let i = 0; i < range.length; i++) {
    if (range[i].active) {
      index = i;
    }
  }
  return index;
};

export const getNextPage = range => {
  let index = getActiveIndex(range);
  index = index + 1 >= range.length ? index : index + 1;
  const next = range[index];
  return next;
};

export const getPrevPage = range => {
  let index = getActiveIndex(range);
  index = index - 1 < 0 ? 0 : index - 1;
  const next = range[index];
  return next;
};

export const getPaginationData = (page, totalPages) => {
  const range = getPageRange(page, totalPages);
  return {
    range,
    first: {index: 1, active: page === 1},
    last: {index: totalPages, active: page === totalPages},
    next: getNextPage(range),
    previous: getPrevPage(range)
  };
};

export const isLastPageInRange = (range, last) => {
  let exist = false;
  range.forEach(page => {
    if (page.index === last) {
      exist = true;
    }
  });

  return exist;
};

export const generatePath = (path: string, page: number, search?: string) => {
  let pageAddition = `page/${page}`;
  if (page === 1) {
    pageAddition = '';
  }
  return `${path.length === 1 ? path : `${path}/`}${pageAddition}${search ? search : ''}`;
};
